import { z } from 'zod'
export const RefuseTaskSchema = z.object({
	justification: z.string().min(1),
})
